import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FocusDirective, GroupByPipe } from './index';
import { YesNoPipe } from './pipe/yesno.pipe';
import { FilterSchemesPipe } from './pipe/filterSchemes.pipe';
import { ExcludeSelectedPipe } from './pipe/excludeSelected.pipe';
import { IncludeSelectedPipe } from './pipe/includeSelected.pipe';


@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
		FocusDirective,
        GroupByPipe,
        YesNoPipe,
        FilterSchemesPipe,
        ExcludeSelectedPipe,
        IncludeSelectedPipe
    ],
    exports: [
		FocusDirective,
        GroupByPipe,
        YesNoPipe,
        FilterSchemesPipe,
        ExcludeSelectedPipe,
        IncludeSelectedPipe
    ]
})
export class SharedModule { }
